/**
 * 「⚡ 戰力 +N」浮動提示(R-004 A3)— 學習入帳讓戰力上升時的克制視覺強調。
 *
 * 觸發點:學習產生 factionXP 入帳後,若 computeCombatPower 變大(解鎖新技能 /
 * 技能升級),在結算/回饋層顯示一次數字浮動。
 *
 * ## 專業 / 克制(boss memory feedback_learn_pro_mode 2026-05-23)
 *   - **無音效**(本檔不 import / 不呼叫任何 sound player)。
 *   - 無 mascot、無彩光,只一行墨綠數字輕浮上淡出。
 *   - delta ≤ 0 → no-op(學習只增不減,但仍防禦)。
 *
 * 樣式走設計系統 `--ef-green` token;動畫由本檔冪等注入的 keyframes 處理。
 */
const STYLE_ID = 'ef-combat-power-popup-style';

function ensurePopupStyle(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    .ef-combat-power-popup {
      position: fixed;
      left: 50%;
      top: 38%;
      transform: translate(-50%, 0);
      z-index: 9998;
      font-family: var(--ef-serif, 'Noto Serif TC', serif);
      font-weight: 700;
      font-size: 30px;
      color: var(--ef-green, #1f6f5c);
      pointer-events: none;
      white-space: nowrap;
      text-shadow: 0 1px 2px rgba(255,255,255,0.7);
      animation: ef-combat-power-float 1500ms ease-out forwards;
    }
    @keyframes ef-combat-power-float {
      0%   { opacity: 0; transform: translate(-50%, 8px) scale(0.9); }
      18%  { opacity: 1; transform: translate(-50%, 0) scale(1.05); }
      35%  { transform: translate(-50%, -2px) scale(1); }
      100% { opacity: 0; transform: translate(-50%, -34px) scale(1); }
    }
    @media (prefers-reduced-motion: reduce) {
      .ef-combat-power-popup { animation-duration: 1ms; }
    }
  `;
  document.head.appendChild(style);
}

/**
 * 顯示「⚡ 戰力 +N」浮動提示。delta ≤ 0 → 不顯示(no-op)。
 * 回傳建立的元素(無 DOM 環境或 no-op → null),方便測試斷言。
 */
export function showCombatPowerGain(delta: number): HTMLElement | null {
  if (!(delta > 0)) return null;
  if (typeof document === 'undefined') return null;

  ensurePopupStyle();
  const el = document.createElement('div');
  el.className = 'ef-combat-power-popup';
  el.setAttribute('data-testid', 'combat-power-gain');
  el.textContent = `⚡ 戰力 +${Math.round(delta)}`;
  document.body.appendChild(el);
  el.addEventListener('animationend', () => el.remove());
  return el;
}
